import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { Collapsible, HtmlField } from 'framework/ui/field';
import { ReplaceUrlWithLink } from 'framework/utils';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';
import { useShowContext } from 'framework/show';
import {
  personTimelineActionNameSx,
  personTimelineDateSx,
  personTimelineHeaderSx,
} from 'domain/shared/timeline/person/PersonTimelineRecord/personTimelineRecordSx';
import { PROJECT_SYSTEM_NOTE_TIMELINE_ICONS, PROJECT_TIMELINE_MESSAGE_CONTEXT } from './constants';
import { ITimelineItem, NotePayload } from './types';
import { Box } from '@mui/material';

const ProjectSystemNoteTimelineRecordHeader = () => {
  const { data: entity } = useShowContext<ITimelineItem<NotePayload>>();

  return (
    <Box sx={personTimelineHeaderSx}>
      <Box sx={personTimelineActionNameSx}>Leonardo DaVinci</Box>
      <Box sx={personTimelineDateSx}>
        <ShowDate dateUTC={entity?.createdAt} format={DATE_FORMAT.FULL} />
      </Box>
    </Box>
  );
};

const ProjectSystemNoteTimelineRecordLayout = (props: Record<string, unknown>) => {
  return (
    <BasePersonTimelineRecordLayout
      actionName=""
      timelineType="SystemNote"
      systemNoteType="SystemNote"
      buttons={[]}
      timelineIcons={PROJECT_SYSTEM_NOTE_TIMELINE_ICONS}
      timelineHeader={ProjectSystemNoteTimelineRecordHeader}
      noteTextSource="payload.text"
      fields={
        <Collapsible>
          <ReplaceUrlWithLink>
            <HtmlField source="payload.text" label="" />
          </ReplaceUrlWithLink>
        </Collapsible>
      }
      permissionToCheck={null}
      isCandidateService={false}
      isShowButtons={() => false}
      messageContext={PROJECT_TIMELINE_MESSAGE_CONTEXT}
      {...props}
    />
  );
};

export default ProjectSystemNoteTimelineRecordLayout;
